import Backend from "./Backend";
import {ReadStatementDto} from "../model/statement/ReadStatementDto";
import {selectedCompanyStore} from "../store/SelectedCompany";
import MatchedDocument from "../model/MatchedDocument";

class StatementApi {

    public fetchStatements(): Promise<ReadStatementDto[]> {
        const companyId = selectedCompanyStore.companyId;
        return Backend.get(`/api/v1/company/${companyId}/statement`);
    }

    public fetchWithArchivedStatements(): Promise<ReadStatementDto[]> {
        const companyId = selectedCompanyStore.companyId;
        return Backend.get(`/api/v1/company/${companyId}/statement/archived`);
    }

    public fetchStatement(id: string): Promise<ReadStatementDto> {
        const companyId = selectedCompanyStore.companyId;
        return Backend.get(`/api/v1/company/${companyId}/statement/${id}`);
    }

    public uploadStatement(iban: string | undefined, currency: string | undefined, base64FileBody: string): Promise<string> {
        const companyId = selectedCompanyStore.companyId;
        return Backend.post(`/api/v1/company/${companyId}/statement`, {
            iban: iban,
            currency: currency,
            file: base64FileBody,
        });
    }

    public deleteStatement(id: string): Promise<void> {
        const companyId = selectedCompanyStore.companyId;
        return Backend.delete(`/api/v1/company/${companyId}/statement/${id}`);
    }

    public analyzeStatement(id: string): Promise<MatchedDocument> {
        const companyId = selectedCompanyStore.companyId;
        return Backend.get(`/api/v1/company/${companyId}/statement/${id}/analyze`);
    }

    public async archiveStatement(id: string): Promise<void> {
        const companyId = selectedCompanyStore.companyId;
        await Backend.put(`/api/v1/company/${companyId}/statement/${id}/archive`);
    }

    public async unarchiveStatement(id: string): Promise<void> {
        const companyId = selectedCompanyStore.companyId;
        await Backend.put(`/api/v1/company/${companyId}/statement/${id}/unarchive`);
    }

    public async saveComment(id: string, comment: string): Promise<void> {
        const companyId = selectedCompanyStore.companyId;
        await Backend.post(`/api/v1/company/${companyId}/statement/${id}/comment`,
                {comment}
        );
    }
}

export const statementApi = new StatementApi();